// "use client";
// import { Form, Formik } from "formik";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import Select from "react-select";
// import UploadSurface from "../components/UploadSurface";
// import { useState } from "react";
// // Static building options
// const propertyTypes = [
//     { value: "building_a", label: "Building A" },
//     { value: "building_b", label: "Building B" },
//     { value: "building_c", label: "Building C" }
// ];

// const ImportData = () => {
//     const [step, setStep] = useState(1);
//     const totalSteps = 2;

//     const nextStep = () => {
//         if (step < totalSteps) setStep(step + 1);
//     };

//     const prevStep = () => {
//         if (step > 1) setStep(step - 1);
//     };
//     return (
//         <div className="admin-page import-data-page">
//             <h1 className="page-section-title">Import Data</h1>
//             <div className="import_filter create-building-form">
//                 <Formik
//                     initialValues={{ building_name: "", property_type: null, valid_from: new Date("2022-08-22") }}
//                     onSubmit={(values) => {
//                         alert(JSON.stringify(values, null, 2));
//                     }}
//                 >
//                     {({ values, setFieldValue }) => (
//                         <Form>
//                             <div className="row">
//                                 <div className="col-md-4">
//                                     <div className="form-group mb-0">
//                                         <label>Select Building</label>
//                                         <div className="custom-select">
//                                             <Select
//                                                 options={propertyTypes}
//                                                 value={values.property_type}
//                                                 onChange={(opt) => setFieldValue("property_type", opt)}
//                                                 placeholder="Select building"
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <div className="form-group mb-0">
//                                         <label>From Date</label>
//                                         <div className="date-picker">
//                                             <DatePicker
//                                                 selected={values.valid_from}
//                                                 onChange={(date) => setFieldValue("valid_from", date)}
//                                                 className="form-control"
//                                                 placeholderText="Select start date"
//                                             />
//                                             <span className="icon"><i className="icon-icon-13"></i></span>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <div className="form-group mb-0">
//                                         <label>To Date</label>
//                                         <div className="date-picker">
//                                             <DatePicker
//                                                 selected={values.valid_from}
//                                                 onChange={(date) => setFieldValue("valid_from", date)}
//                                                 className="form-control"
//                                                 placeholderText="Select start date"
//                                             />
//                                             <span className="icon"><i className="icon-icon-13"></i></span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </Form>
//                     )}
//                 </Formik>
//             </div>
//             <div className="import-step-date d-flex align-items-center mb-4">
//                 {[...Array(totalSteps)].map((_, index) => {
//                     const current = index + 1;
//                     let stepClass = "";

//                     if (step === current) {
//                         stepClass = "active";
//                     } else if (step > current) {
//                         stepClass = "previous";
//                     }

//                     return (
//                         <div key={current} className={`step ${stepClass}`}>
//                             {current}
//                         </div>
//                     );
//                 })}
//             </div>
//             {step === 1 && (
//                 <div className="import_data_form">
//                     <div className="radio_list_import d-flex align-items-center flex-wrap">
//                         <label htmlFor="surface">
//                             <input type="radio" id="surface" name="import-data" />
//                             <span>Surface Data</span>
//                         </label>
//                         <label htmlFor="cost">
//                             <input type="radio" id="cost" name="import-data" />
//                             <span>Cost Data</span>
//                         </label>
//                         <label htmlFor="energy">
//                             <input type="radio" id="energy" name="import-data" />
//                             <span>Energy Consumption</span>
//                         </label>
//                     </div>
//                     <UploadSurface />
//                     {/* <div className="button-group d-flex align-items-center mt-4">
//                         <button type="submit" className="btns">Import Data</button>
//                     </div> */}
//                 </div>
//             )}
//             {step === 2 && (
//                 <div className="import_data_form">
//                     <div className="radio_list_import d-flex align-items-center flex-wrap">
//                         <label htmlFor="object">
//                             <input type="radio" id="object" name="importdata" />
//                             <span>Object</span>
//                         </label>
//                         <label htmlFor="etc">
//                             <input type="radio" id="etc" name="importdata" />
//                             <span>ETC</span>
//                         </label>
//                         <label htmlFor="djf">
//                             <input type="radio" id="djf" name="importdata" />
//                             <span>DJF</span>
//                         </label>
//                         <label htmlFor="nj">
//                             <input type="radio" id="nj" name="importdata" />
//                             <span>NJ</span>
//                         </label>
//                     </div>
//                     <UploadSurface />
//                 </div>
//             )}

//             <div className="button-group d-flex align-items-center mt-4 justify-content-between">
//                 <button type="submit" className="btns">
//                     Import Data
//                 </button>

//                 {/* Navigation Buttons */}
//                 {step === 1 && (
//                     <button onClick={nextStep} className="btns">
//                         Next
//                     </button>
//                 )}
//                 {step > 1 && (
//                     <button onClick={prevStep} className="btns">
//                         Back
//                     </button>
//                 )}
//             </div>
//         </div>
//     )
// }

// export default ImportData;


// "use client";
// import { Form, Formik } from "formik";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import Select from "react-select";
// import UploadSurface from "../components/UploadSurface";
// import { useState, useEffect } from "react";
// import axios from "axios";

// const ImportData = () => {
//     const [step, setStep] = useState(1);
//     const totalSteps = 2;

//     // For building-period options
//     const [buildingOptions, setBuildingOptions] = useState([]);
//     const [loadingBuildings, setLoadingBuildings] = useState(false);

//     const fetchBuildings = async () => {
//         try {
//             setLoadingBuildings(true);
//             const res = await axios.get(`${process.env.REACT_APP_API_URL}building/list`, {
//                 headers: {
//                     "api-key": process.env.REACT_APP_API_KEY,
//                     Authorization: `Bearer ${localStorage.getItem("token")}`,
//                 },
//                 params: {
//                     page: 1,
//                     pageSize: 100,
//                 },
//             });

//             if (res.data.status === "success") {
//                 const buildings = res.data.data.buildings || [];

//                 // Flatten buildings + periods
//                 const formatted = buildings.flatMap((b: any) =>
//                     (b.periods || []).map((p: any) => ({
//                         value: {
//                             buildingId: b.id,
//                             buildingName: b.building_name,
//                             from: p.from,
//                             to: p.to,
//                         },
//                         label: `${b.building_name} (${p.from} - ${p.to})`,
//                     }))
//                 );

//                 setBuildingOptions(formatted);
//             } else {
//                 setBuildingOptions([]);
//             }
//         } catch (err) {
//             console.error("Error fetching buildings:", err);
//             setBuildingOptions([]);
//         } finally {
//             setLoadingBuildings(false);
//         }
//     };

//     const parseDate = (dateStr: string) => {
//         if (!dateStr) return null;
//         const [day, month, year] = dateStr.split("/");
//         return new Date(Number(year), Number(month) - 1, Number(day));
//       };

//     useEffect(() => {
//         fetchBuildings();
//     }, []);

//     const nextStep = () => {
//         if (step < totalSteps) setStep(step + 1);
//     };

//     const prevStep = () => {
//         if (step > 1) setStep(step - 1);
//     };

//     return (
//         <div className="admin-page import-data-page">
//             <h1 className="page-section-title">Import Data</h1>
//             <div className="import_filter create-building-form">
//                 <Formik
//                     initialValues={{
//                         property_type: null,
//                         valid_from: null,
//                         valid_to: null,
//                     }}
//                     onSubmit={(values) => {
//                         alert(JSON.stringify(values, null, 2));
//                     }}
//                 >
//                     {({ values, setFieldValue }) => (
//                         <Form>
//                             <div className="row">
//                                 <div className="col-md-4">
//                                     <div className="form-group mb-0">
//                                         <label>Select Building</label>
//                                         <div className="custom-select">
//                                         <Select
//   options={buildingOptions}
//   isLoading={loadingBuildings}
//   value={values.property_type}
//   onChange={(opt) => {
//     setFieldValue("property_type", opt);
//     setFieldValue("valid_from", parseDate(opt.value.from));
//     setFieldValue("valid_to", parseDate(opt.value.to));
//   }}
//   placeholder="Select building"
// />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <div className="form-group mb-0">
//                                         <label>From Date</label>
//                                         <div className="date-picker">
//                                             <DatePicker
//                                                 selected={values.valid_from}
//                                                 readOnly
//                                                 className="form-control"
//                                                 // placeholderText="Auto-filled"
//                                             />
//                                             <span className="icon"><i className="icon-icon-13"></i></span>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <div className="form-group mb-0">
//                                         <label>To Date</label>
//                                         <div className="date-picker">
//                                             <DatePicker
//                                                 selected={values.valid_to}
//                                                 readOnly
//                                                 className="form-control"
//                                                 // placeholderText="Auto-filled"
//                                             />
//                                             <span className="icon"><i className="icon-icon-13"></i></span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </Form>
//                     )}
//                 </Formik>
//             </div>

//             {/* Step navigation */}
//             <div className="import-step-date d-flex align-items-center mb-4">
//                 {[...Array(totalSteps)].map((_, index) => {
//                     const current = index + 1;
//                     let stepClass = "";
//                     if (step === current) stepClass = "active";
//                     else if (step > current) stepClass = "previous";
//                     return (
//                         <div key={current} className={`step ${stepClass}`}>
//                             {current}
//                         </div>
//                     );
//                 })}
//             </div>

//             {/* Step 1 */}
//             {step === 1 && (
//                 <div className="import_data_form">
//                     <div className="radio_list_import d-flex align-items-center flex-wrap">
//                         <label htmlFor="surface">
//                             <input type="radio" id="surface" name="import-data" />
//                             <span>Surface Data</span>
//                         </label>
//                         <label htmlFor="cost">
//                             <input type="radio" id="cost" name="import-data" />
//                             <span>Cost Data</span>
//                         </label>
//                         <label htmlFor="energy">
//                             <input type="radio" id="energy" name="import-data" />
//                             <span>Energy Consumption</span>
//                         </label>
//                     </div>
//                     <UploadSurface />
//                 </div>
//             )}

//             {/* Step 2 */}
//             {step === 2 && (
//                 <div className="import_data_form">
//                     <div className="radio_list_import d-flex align-items-center flex-wrap">
//                         <label htmlFor="object">
//                             <input type="radio" id="object" name="importdata" />
//                             <span>Object</span>
//                         </label>
//                         <label htmlFor="etc">
//                             <input type="radio" id="etc" name="importdata" />
//                             <span>ETC</span>
//                         </label>
//                         <label htmlFor="djf">
//                             <input type="radio" id="djf" name="importdata" />
//                             <span>DJF</span>
//                         </label>
//                         <label htmlFor="nj">
//                             <input type="radio" id="nj" name="importdata" />
//                             <span>NJ</span>
//                         </label>
//                     </div>
//                     <UploadSurface />
//                 </div>
//             )}

//             <div className="button-group d-flex align-items-center mt-4 justify-content-between">
//                 <button type="submit" className="btns">Import Data</button>
//                 {step === 1 && (
//                     <button onClick={nextStep} className="btns">Next</button>
//                 )}
//                 {step > 1 && (
//                     <button onClick={prevStep} className="btns">Back</button>
//                 )}
//             </div>
//         </div>
//     )
// }

// export default ImportData;



"use client";
import { Form, Formik, Field, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import UploadSurface from "../components/UploadSurface";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import * as Yup from "yup";

/* -------------------------- Validation Schema -------------------------- */
// Phase 3 (A10): added `cost_invoice` so operators can upload the new per-invoice
// Excel template alongside the existing aggregate types. The backend handler
// already supports type='cost_invoice' end-to-end (see modules/api/Import).
const ALL_TYPES = ["surface", "cost", "cost_invoice", "energy", "object", "etc", "djf", "nj"];
const validationSchema = Yup.object().shape({
  property_type: Yup.mixed().required("Please select a building/time period"),
  importType: Yup.string().oneOf(ALL_TYPES, "Please select a valid data type").required("Please select a data type"),
  file: Yup.mixed().required("Please upload an Excel (.xlsx) file"),
});

/* -------------------------- Helpers -------------------------- */
const parseDate = (input) => {
  if (!input) return null;
  // Already a Date
  if (input instanceof Date && !isNaN(input.getTime())) return input;
  const s = String(input);
  // Try DD/MM/YYYY
  const slashParts = s.split("/");
  if (slashParts.length === 3) {
    const [day, month, year] = slashParts;
    const d = new Date(Number(year), Number(month) - 1, Number(day));
    if (!isNaN(d.getTime())) return d;
  }
  // Try ISO or native Date parser
  const d2 = new Date(s);
  return isNaN(d2.getTime()) ? null : d2;
};

const formatDateForLabel = (dateStr) => {
  if (!dateStr) return "";
  return dateStr;
};

const BUILDING_ID_PARAM = "buildingId";
const PERIOD_ID_PARAM = "periodId";
const DEFAULT_FORM_VALUES = {
  property_type: null,
  importType: "",
  file: null,
  valid_from: null,
  valid_to: null,
};

/* -------------------------- Component -------------------------- */
const ImportData = () => {
  const [buildingOptions, setBuildingOptions] = useState([]);
  const [loadingBuildings, setLoadingBuildings] = useState(false);
  const [initialFormValues, setInitialFormValues] = useState(DEFAULT_FORM_VALUES);
  const [searchParams, setSearchParams] = useSearchParams();

  /* ------------------ Fetch Buildings ------------------ */
  const fetchBuildings = async () => {
    try {
      setLoadingBuildings(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}building/list`, {
        headers: {
          "api-key": process.env.REACT_APP_API_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: { page: 1, pageSize: 100 },
      });

      if (res?.data?.status === "success") {
        const buildings = res.data.data.buildings || [];
        const formatted = buildings.flatMap((b) =>
          (b.periods || []).map((p) => {
            const fromStr = p.from || p.start_date || p.valid_from || p.begin || '';
            const toStr = p.to || p.end_date || p.valid_to || p.end || '';
            return {
              value: {
                buildingId: b.id,
                buildingName: b.building_name,
                ownerName: b.owner_name,
                from: fromStr,
                to: toStr,
                periodId: p.id,
                property_type: b.property_type,
                building_size: b.building_size,
              },
              label: `${b.building_name} (${formatDateForLabel(fromStr)} - ${formatDateForLabel(toStr)})`,
            };
          })
        );
        setBuildingOptions(formatted);

        // Restore selection from URL (instead of localStorage)
        const buildingId = searchParams.get(BUILDING_ID_PARAM);
        const periodId = searchParams.get(PERIOD_ID_PARAM);
        if (!buildingId || !periodId) {
          setInitialFormValues(DEFAULT_FORM_VALUES);
          return;
        }

        const matchedOption = formatted.find((opt) => {
          const val = opt?.value || {};
          return String(val.buildingId) === String(buildingId) && String(val.periodId) === String(periodId);
        });

        if (!matchedOption) {
          setInitialFormValues(DEFAULT_FORM_VALUES);
          return;
        }

        setInitialFormValues({
          property_type: matchedOption,
          importType: "",
          file: null,
          valid_from: parseDate(matchedOption?.value?.from),
          valid_to: parseDate(matchedOption?.value?.to),
        });
      } else {
        setBuildingOptions([]);
      }
    } catch (err) {
      console.error("Error fetching buildings:", err);
      setBuildingOptions([]);
    } finally {
      setLoadingBuildings(false);
    }
  };

  useEffect(() => {
    fetchBuildings();
  }, []);

  return (
    <div className="admin-page import-data-page">
      <h1 className="page-section-title">Import Data</h1>

      <div className="import_filter create-building-form">
        <Formik
          initialValues={initialFormValues}
          enableReinitialize
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          onSubmit={async (values, { resetForm, setSubmitting }) => {
            try {
              setSubmitting(true);

              const chosen = values.property_type.value;
              const building_id = chosen.buildingId;
              const building_time_period_id = chosen.periodId;
              // Map UI importType to API type
              const typeMap = {
                surface: 'surface',
                cost: 'cost',
                cost_invoice: 'cost_invoice',
                energy: 'consumption',
                object: 'object',
                etc: 'etc',
                djf: 'djf',
                nj: 'nj',
              };
              const apiType = typeMap[values.importType] || values.importType;

              const fd = new FormData();
              fd.append('building_id', String(building_id));
              fd.append('building_time_period_id', String(building_time_period_id));
              fd.append('type', apiType);
              fd.append('file', values.file);

              const res = await axios.post(
                `${process.env.REACT_APP_API_URL}import/upload`,
                fd,
                {
                  headers: {
                    'api-key': process.env.REACT_APP_API_KEY || '',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'multipart/form-data',
                  },
                }
              );

              if (res?.data?.status === 'success') {
                window.alert(`Imported ${res?.data?.data?.inserted || 0} rows for ${apiType}`);
                resetForm({
                  values: {
                    property_type: values.property_type,
                    importType: "",
                    file: null,
                    valid_from: values.valid_from,
                    valid_to: values.valid_to,
                  },
                });
              } else {
                const msg = res?.data?.message || 'Import failed';
                window.alert(msg);
              }
            } catch (err) {
              console.error('Import error:', err);
              const msg = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : (err && err.message ? err.message : 'Import failed');
              window.alert(msg);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ values, setFieldValue, setFieldTouched, setFieldError, isSubmitting, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              {/* Debug Validation Errors */}
              {/* {Object.keys(errors).length > 0 && Object.keys(touched).length > 0 && (
                <div className="invalid-feedback d-block mb-2">
                  Form errors: {JSON.stringify(errors)}
                </div>
              )} */}

              {/* ------------------------- Row: Select + Dates ------------------------- */}
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group mb-0">
                    <label>Select Building</label>
                    <div className="custom-select">
                      <Select
                        options={buildingOptions}
                        isLoading={loadingBuildings}
                        value={values.property_type}
                        getOptionLabel={(o) => o.label}
                        getOptionValue={(o) => JSON.stringify(o.value)}
                        onChange={(opt) => {
                          console.log("Selected building:", opt);
                          setFieldValue("property_type", opt);
                          // Auto-fill date fields based on the selected building period
                          try {
                            const from = opt && opt.value && opt.value.from ? opt.value.from : null;
                            const to = opt && opt.value && opt.value.to ? opt.value.to : null;
                            setFieldValue("valid_from", parseDate(from));
                            setFieldValue("valid_to", parseDate(to));
                          } catch (_) {
                            setFieldValue("valid_from", null);
                            setFieldValue("valid_to", null);
                          }
                          if (!opt) {
                            const next = new URLSearchParams();
                            setSearchParams(next, { replace: true });
                            return;
                          }
                          const next = new URLSearchParams();
                          next.set(BUILDING_ID_PARAM, String(opt.value.buildingId));
                          next.set(PERIOD_ID_PARAM, String(opt.value.periodId));
                          setSearchParams(next, { replace: true });
                        }}
                        placeholder="Select building"
                        isClearable
                      />
                    </div>
                    <ErrorMessage name="property_type">
                      {(msg) => <div className="invalid-feedback d-block">{msg}</div>}
                    </ErrorMessage>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group mb-0">
                    <label>From Date</label>
                    <div className="date-picker">
                      <DatePicker
                        selected={values.valid_from}
                        onChange={(date) => setFieldValue("valid_from", date)}
                        className="form-control"
                        placeholderText="Auto-filled"
                        readOnly
                        dateFormat="dd/MM/yyyy"
                      />
                      <span className="icon"><i className="icon-icon-13"></i></span>
                    </div>
                    <ErrorMessage name="valid_from">
                      {(msg) => <div className="invalid-feedback d-block">{msg}</div>}
                    </ErrorMessage>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group mb-0">
                    <label>To Date</label>
                    <div className="date-picker">
                      <DatePicker
                        selected={values.valid_to}
                        onChange={(date) => setFieldValue("valid_to", date)}
                        className="form-control"
                        placeholderText="Auto-filled"
                        readOnly
                        dateFormat="dd/MM/yyyy"
                      />
                      <span className="icon"><i className="icon-icon-13"></i></span>
                    </div>
                    <ErrorMessage name="valid_to">
                      {(msg) => <div className="invalid-feedback d-block">{msg}</div>}
                    </ErrorMessage>
                  </div>
                </div>
              </div>

              <Field type="hidden" name="building_name" />
              <Field type="hidden" name="owner_name" />
              <Field type="hidden" name="property_address" />
              <Field type="hidden" name="building_address" />
              <div className="d-none">
                <Field name="managing_addresses[0]" />
              </div>

              <div className="import_data_form mt-4">
                <div className="radio_list_import d-flex align-items-center flex-wrap">
                  <label htmlFor="surface">
                    <Field type="radio" id="surface" name="importType" value="surface" />
                    <span>Surface Data</span>
                  </label>
                  <label htmlFor="cost">
                    <Field type="radio" id="cost" name="importType" value="cost" />
                    <span>Cost Data</span>
                  </label>
                  <label htmlFor="cost_invoice">
                    <Field type="radio" id="cost_invoice" name="importType" value="cost_invoice" />
                    <span>Cost Invoices</span>
                  </label>
                  <label htmlFor="energy">
                    <Field type="radio" id="energy" name="importType" value="energy" />
                    <span>Energy Consumption</span>
                  </label>
                  <label htmlFor="object">
                    <Field type="radio" id="object" name="importType" value="object" />
                    <span>Object</span>
                  </label>
                  <label htmlFor="etc">
                    <Field type="radio" id="etc" name="importType" value="etc" />
                    <span>ETC</span>
                  </label>
                  <label htmlFor="djf">
                    <Field type="radio" id="djf" name="importType" value="djf" />
                    <span>DJF</span>
                  </label>
                  <label htmlFor="nj">
                    <Field type="radio" id="nj" name="importType" value="nj" />
                    <span>NJ</span>
                  </label>
                </div>
                <ErrorMessage name="importType">
                  {(msg) => <div className="invalid-feedback d-block">{msg}</div>}
                </ErrorMessage>

                <UploadSurface setFieldValue={setFieldValue} setFieldTouched={setFieldTouched} setFieldError={setFieldError} file={values.file} />
                <ErrorMessage name="file">
                  {(msg) => <div className="invalid-feedback d-block mt-2">{msg}</div>}
                </ErrorMessage>
              </div>

              <div className="button-group d-flex align-items-center mt-4">
                <button
                  type="submit"
                  className="btns"
                  disabled={isSubmitting}
                  onClick={() => console.log("Submit button clicked")} // Debug log
                >
                  {isSubmitting ? "Importing..." : "Import Data"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ImportData;